import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Instagram, MapPin } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export const Footer = () => {
  const { user } = useAuth();
  return (
    <footer className="bg-[#030303] border-t border-gray-900 mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <span className="font-black text-2xl tracking-tighter uppercase" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                <span style={{ color: '#E63946' }}>SAC</span>
                <span className="text-white"> EVENTS</span>
              </span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed">
              Your premier destination for sports events, festivals, fashion shows, and nightlife experiences across Poland and Europe.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="https://instagram.com/sac_event_" target="_blank" rel="noreferrer" className="text-gray-500 hover:text-pink-400 transition-colors">
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold uppercase tracking-wider text-xs text-gray-500 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[['Explore Events', '/explore'], ['My Tickets', '/my-tickets'], user ? ['My Profile', '/account'] : ['Sign In', '/auth'], ['Organiser Dashboard', '/organiser']].map(([label, href]) => (
                <li key={href}>
                  <Link to={href} className="text-gray-400 hover:text-white text-sm transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-bold uppercase tracking-wider text-xs text-gray-500 mb-4">Categories</h4>
            <ul className="space-y-2">
              {['Sports Events', 'Festivals', 'Fashion Events', 'Networking', 'Nightlife'].map(cat => (
                <li key={cat}>
                  <Link to={`/explore?category=${cat.toLowerCase().replace(' ', '_')}`} className="text-gray-400 hover:text-white text-sm transition-colors">{cat}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold uppercase tracking-wider text-xs text-gray-500 mb-4">Contact</h4>
            <div className="space-y-3">
              <a href="mailto:support@sacevents.space" className="flex items-center gap-2 text-gray-400 hover:text-white text-sm transition-colors">
                <Mail size={14} />
                support@sacevents.space
              </a>
              <a href="tel:+48608723864" className="flex items-center gap-2 text-gray-400 hover:text-white text-sm transition-colors">
                <Phone size={14} />
                +48 608 723 864
              </a>
              <a href="tel:+48608702727" className="flex items-center gap-2 text-gray-400 hover:text-white text-sm transition-colors">
                <Phone size={14} />
                +48 608 702 727
              </a>
              <div className="flex items-center gap-2 text-gray-500 text-sm">
                <MapPin size={14} />
                Warsaw & Kraków, Poland
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-900 mt-10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs">
            © {new Date().getFullYear()} SAC EVENTS. All rights reserved. | GDPR Compliant
          </p>
          <div className="flex items-center gap-4">
            <Link to="/legal" className="text-gray-600 hover:text-gray-400 text-xs transition-colors">Privacy Policy</Link>
            <Link to="/legal" className="text-gray-600 hover:text-gray-400 text-xs transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
